import {StyleSheet} from 'react-native';

import {darkRed} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  text: {
    fontFamily: 'Open Sans',
    fontWeight: '400',
    fontSize: 14,
    lineHeight: 18,
  },
  expired: {
    color: darkRed,
    fontWeight: 600,
  },
  notExpired: {
    color: '#1D1D1D',
  },
});
